import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '@/components/Header';
import Sidebar from '@/components/Sidebar';
import ToastStack from '@/components/ToastStack';
import KeyboardShortcutsHelp from '@/components/KeyboardShortcutsHelp';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import { useNotificationStream } from '@/hooks/useNotificationStream';

const AppLayout: React.FC = () => {
  const [showHelp, setShowHelp] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  useNotificationStream();

  // Global keyboard shortcuts
  useKeyboardShortcuts({
    shortcuts: [
      {
        key: '?',
        shiftKey: true,
        callback: () => setShowHelp(true),
        description: '? to show help',
      },
      {
        key: 'Escape',
        callback: () => {
          setShowHelp(false);
          setMobileSidebarOpen(false);
        },
        description: 'ESC to close help',
        preventDefault: false,
      },
    ],
  });

  return (
    <div className="relative min-h-screen bg-slate-100 text-slate-900">
      <ToastStack />
      <KeyboardShortcutsHelp isOpen={showHelp} onClose={() => setShowHelp(false)} />
      <div className="flex min-h-screen bg-[radial-gradient(circle_at_top,_#e0f2fe,_#eef2ff_50%,_#f8fafc)]">
        <Sidebar 
          isMobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
        />
        <div className="flex min-h-screen flex-1 flex-col">
          <Header onMenuClick={() => setMobileSidebarOpen(true)} />
          <main className="flex-1 overflow-y-auto p-4 sm:p-6 md:p-10">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default AppLayout;
